<!-- class="hogehoge" → styleで.hogehogeでスタイル指定できる -->
<template>
  <div>
    <div class="container">
      <div class="breadCrumbsContainer" style="display: flex;">
        パスワードを再発行するために、ログインIDをご入力下さい。
        <div class="headerBtn" @click="screenTransition()" style="margin: 0px 0px 0px 20px;">ログイン画面に戻る</div>
      </div>
      <!-- ローディング -->
      <div v-if="sendLodingFlg">
        <vue-loading
          type="cylon"
          color="#1b7e47"
          :size="{ width: '150px', height: '150px' }"
        >
        </vue-loading>
        <div style="padding: 0px 0px 30px 0px;">Now loading...</div>
      </div>
      <!-- 更新エラー表示 -->
      <div v-if="sendErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
        <div　class="errMsg">
          <div class="errSpan" style="font-size:x-large;">
            メール送信中に問題が発生しました。
          </div>
        </div>
      </div>
      <form>
        <validation-observer ref="obs" v-slot="ObserverProps">
          <p class="inputTitle">ログインID</p>
          <validation-provider name="ログインID" rules="required" mode="lazy">
            <div slot-scope="ProviderProps">
              <input class="text small" style="width: 500px" v-model="loginId">
              <div class="errMsg" v-if="ProviderProps.errors[0]">
                <span class="errSpan">
                  {{ ProviderProps.errors[0] }}
                </span>
              </div>
            </div>
          </validation-provider>
          <div class="buttonGroup">
            <button class="btn" type="button" @click="confirm"
              v-bind:class="{ disabled: ObserverProps.invalid || !ObserverProps.validate, active: !ObserverProps.invalid && ObserverProps.validate}"
              :disabled="ObserverProps.invalid || !ObserverProps.validated">送信
            </button>
          </div>
        </validation-observer>
      </form>
      <label class="forget" style="" @click="forgotLoginId">ログインIDを忘れた場合</label>
    </div>
  </div>

</template>

<script lang='ts'>
import { Component, Vue } from 'vue-property-decorator';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required, max, min, email } from 'vee-validate/dist/rules';
import ApiClient from '../services/ApiClient';
import { VueLoading } from 'vue-loading-template';

export default {
  title: 'パスワード再発行準備',
  components: {
    ValidationProvider,
    ValidationObserver,
    VueLoading,
  },
  data() {
    return {
      loginId: '',
      // ローディング
      sendLodingFlg: false,  // メール送信ローディングフラグ
      sendErrorFlg: false,   // メール送信時エラーフラグ
      loginIdErrorFlg: false,   // メール送信時エラーフラグ
    };
  },
  computed: {
  },
  watch: {
  },
  methods: {
    // 変更ボタン押下時処理
    async confirm() {
      try {
        this.sendErrorFlg = false;
        this.sendLodingFlg = true;
        // メールアドレスへ確認コードを送信
        await this.$cognito.forgetPassword(this.loginId)
        .then((result) => {
          // パスワードリセット画面へ遷移
          this.$router.push({
            name: 'PasswordReset',
            params: {
              loginId: this.loginId,
            },
          });
        })
        .catch((err) => {
          this.loginIdErrorFlg = true;
        });
      } catch (error) {
        this.sendErrorFlg = true;
      } finally {
        this.sendLodingFlg = false;
      }
    },
    // ログイン画面へ遷移
    screenTransition() {
      this.$router.push('/');
    },
    // パスワード忘れ再発行画面へ遷移
    forgotLoginId() {
      this.$router.push('/users/forgot-login-id');
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../style/variables.scss";

.forget {
  text-align: left;
  display: block;
  margin-top: 5%;
  position: relative;
  text-decoration: none;
  color: $font_color;
  font-weight: bold;
  cursor: pointer;
}

</style>
